import React, { useEffect } from 'react';
const AarDescription = (obj: any) => {
    var interval: any = null;
    useEffect(() => {
        if(interval) {
            clearInterval(interval);
            interval = null;
        }

        interval = setInterval(() => {
            if((window['selectedArrItemId' as any] as any)===obj.id) {
                document.getElementById('aar-item-' + obj.id).getElementsByTagName('p')[0].focus();
                clearInterval(interval);
                interval = null;
            }
        }, 1000);
    })
    // useEffect(() => {
    //     if(obj.selectedIndx === obj.id) {
    //         setTimeout(() => {
    //             document.getElementById('aar-item-' + obj.id).focus();
    //         }, 1000);
    //     }
        
    // }, [obj.selectedIndx])
	return (
        <div id={"aar-item-" + obj.id} className="aar-single-action-item-txt" style={{
            display: obj.show ? 'block' : 'none'
        }}>
            <p tabIndex={0}>{obj.isCorrect ? obj.correctFeedback : obj.incorrectFeedback}</p>
        </div>
	);
};

export default AarDescription;
